import { render } from "./DriveMain.vue?vue&type=template&id=19c8662b&scoped=true&ts=true"
import script from "./DriveMain.vue?vue&type=script&lang=ts"
export * from "./DriveMain.vue?vue&type=script&lang=ts"

import "./DriveMain.vue?vue&type=style&index=0&id=19c8662b&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c8662b"]])

export default __exports__